import React, { Component } from 'react'

export class Footer extends Component {
    render() {
        return (
            <footer className="app-footer">
                <div className="footer-content">
                    <p className="footer-text">© {new Date().getFullYear()} MYPacome. Tous droits réservés.</p>
                </div>
            </footer>
        )
    }
}

export default Footer